export const chatbotMessage =
  '<p>Hola, soy el asistente virtual de BICE VIDA, estoy en mi versión de prueba y aprendiendo sobre seguros, pero tengo muchas ganas de ayudarte a resolver tus dudas. ¿Qué necesitas?</p>';
